import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import Chevron from '../../atoms/Chevron';
import './ListOfButtons.scss';

function ListOfButtons({ buttons = [], staffOnlybuttons = [], startingIndex = -1, onClick = () => {} }) {
  const [selectedIndex, setSelectedIndex] = useState(startingIndex || -1);
  const [staffIsOpen, setStaffIsOpen] = useState(true);
  const location = useLocation();
  const offset = buttons.length;

  useEffect(() => {
    buttons.forEach((button, i) => {
      if (button.pathMatch.test(location.pathname + decodeURIComponent(location.search))) {
        setSelectedIndex(i);
      }
    });

    staffOnlybuttons?.forEach((button, i) => {
      if (button.pathMatch.test(location.pathname)) {
        setSelectedIndex(i + offset);
      }
    });
  }, [location.pathname, location.search, buttons, staffOnlybuttons]);

  return (
    <>
      <div className="ListOfButtons-section">
        <ul className="buttonHolder">
          {buttons.map((button, i) => (
            <li
              key={`${button.url}`}
              className={`noselect ${selectedIndex === i ? 'selected' : ''} ${button.mobile ? '' : 'hideMobile'}`}
            >
              <Link className="ListOfButtons-link" to={button.url} onClick={onClick}>
                {button.icon}
                <div className="buttonText">{button.text}</div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      {staffOnlybuttons?.length > 0 ? (
        <div className="ListOfButtons-section staffButtonHolder">
          <p
            className="staffOnlyTitle "
            onClick={() => {
              setStaffIsOpen(!staffIsOpen);
            }}
          >
            Staff Only
            <Chevron className="ListOfButtons-chevron" open={staffIsOpen} />
          </p>
          {staffIsOpen && (
            <ul className="buttonHolder staffButtons">
              {staffOnlybuttons.map((button, i) => (
                <li
                  key={`${button.url}`}
                  className={`noselect ${selectedIndex === i + offset ? 'selected' : ''} ${
                    button.mobile ? '' : 'hideMobile'
                  }`}
                >
                  <Link className="ListOfButtons-link" to={button.url} onClick={onClick}>
                    {button.icon}
                    <div className="buttonText">{button.text}</div>
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      ) : null}
    </>
  );
}

ListOfButtons.propTypes = {
  buttons: PropTypes.array,
  staffOnlybuttons: PropTypes.array,
  startingIndex: PropTypes.number,
  onClick: PropTypes.func,
};

export default ListOfButtons;
